import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getInputGroupEl } from "./avm-utils";
import { NullHTMLElementError } from "./Errors/NullHTMLElementError";
//@ts-ignore
import { decodeTextWithEntities, replaceAllTokens } from "@utils/StringUtils";
var EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/im;
var PHONE_REGEX = /([0-1]?[1-9][/.][0-1][0-9][/.]\d{2,4})|(\+?[0-9])([/\\ .-]*[0-9]){8,}/g;
export var createValidationObj = function createValidationObj(isValid) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return {
    isValid,
    message
  };
};
//@ts-ignore
// eslint-disable-next-line max-len
export var getValidationLabel = (labelKey, mapObj) => decodeTextWithEntities(replaceAllTokens(window["validationLabels"][labelKey], mapObj));
export function required(fieldName) {
  fieldName = fieldName.toLowerCase();
  return value => "".concat(value).length > 0 ? createValidationObj(true) : createValidationObj(false, getValidationLabel("requestedField", {
    "{0}": fieldName
  }));
}
/**
 * Creates an upper ot bottom bound to given number
 * @param digitNumber The number of digits for the limit number
 * @param isUpper Specifies if the limit number is an upper or bottom limit
 */
var createLimit = (digitNumber, isUpper) => {
  if (digitNumber < 0) throw new Error("The digitNumber must be positive");
  if (!isUpper && digitNumber === 1) return 0;
  return isUpper ? parseInt("1".concat("0".repeat(digitNumber)), 10) : parseInt("1".concat("0".repeat(digitNumber - 1)), 10);
};
/**
 * Check if the value is a number
 */
export function isNumber(fieldName) {
  fieldName = fieldName.toLowerCase();
  return value => {
    //@ts-ignore
    return !isNaN(value) ? createValidationObj(true, "") : createValidationObj(false, getValidationLabel("isNAN", {
      "{0}": fieldName
    }));
  };
}
/**
 * Checks if a number is positive and greater than a number whose digits are equal to digitNumber
 */
export var greaterThan = digitNumber => fieldName => value => {
  fieldName = fieldName.toLowerCase();
  var number = parseInt(value, 10);
  if (Number.isNaN(number)) return createValidationObj(false);
  var limitNumber = createLimit(digitNumber, false);
  return number >= limitNumber ? createValidationObj(true, "") : createValidationObj(false, getValidationLabel("greaterThan", {
    "{0}": fieldName,
    "{1}": "".concat(digitNumber)
  }));
};
/**
 * Checks if a number is positive and less than a number whose digits are equal to digitNumber
 */
export var lessThan = digitNumber => fieldName => value => {
  var number = parseInt(value, 10);
  if (Number.isNaN(number)) return createValidationObj(false);
  var limitNumber = createLimit(digitNumber, true);
  return number >= 0 && number < limitNumber ? createValidationObj(true, "") : createValidationObj(false, getValidationLabel("lessThan", {
    "{0}": fieldName,
    "{1}": "".concat(digitNumber)
  }));
};
/**
 * Checks if the length of the given value is less than max
 * @param max The maximum length of the string
 * */
export var maxStringLength = max => fieldName => value => value.trim().length <= max ? createValidationObj(true) : createValidationObj(false, getValidationLabel("invalidStringLength", {
  "{0}": fieldName
}));
export var isEmail = fieldName => value => value.match(EMAIL_REGEX) ? createValidationObj(true)
//@ts-ignore
: createValidationObj(false, window["validationLabels"].invalidEmail);
export var isPhone = fieldName => value => "".concat(value).match(PHONE_REGEX) ? createValidationObj(true) : createValidationObj(false,
//@ts-ignore
window["validationLabels"].invalidPhone);
export function createPredicate(pred) {
  return fieldName => pred;
}
export function validate(predicates, el, valueToValidate) {
  var fieldName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  if (!predicates) return createValidationObj(true, "");
  var value = valueToValidate;
  var inputGroupEl = getInputGroupEl(el);
  if (!inputGroupEl) throw new NullHTMLElementError(el.getAttribute("id") || "");
  var id = el.getAttribute("id");
  var messageEl = document.getElementById("".concat(id, "_invalid"));
  for (var predicate of predicates) {
    var res = predicate(fieldName)(value);
    if (!res.isValid) {
      if (!messageEl) {
        var _messageEl = document.createElement("p");
        _messageEl.setAttribute("id", "".concat(id, "_invalid"));
        _messageEl.innerText = res.message;
        el.insertAdjacentElement("afterend", _messageEl);
        /* Placing the validation classes in the parent element: input-group */
        inputGroupEl.classList.add("invalid");
        inputGroupEl.classList.remove("valid");
      } else {
        messageEl.innerText = res.message;
      }
      return res;
    }
  }
  /* Adding validation classes */
  inputGroupEl.classList.add("valid");
  inputGroupEl.classList.remove("invalid");
  //Now that the input is valid, the message is not required anymore
  messageEl && messageEl.remove();
  return {
    isValid: true,
    message: ""
  };
}